export default [
    {
        path: "/pay",
        name: "payment_center",
        component: () => import(/* webpackChunkName: "payment_center" */ "../views/user/Payment.vue"),
        meta: { requiresAuth: true }
    }
]